document.addEventListener('DOMContentLoaded', () => {
  const lightbox     = document.getElementById('tm-lightbox');
  const pagesContainer = document.getElementById('tm-lightbox__pages');
  const captionEl    = document.getElementById('tm-lightbox__caption');
  const btnClose     = lightbox.querySelector('.tm-lightbox__close');
  const btnPrev      = lightbox.querySelector('.tm-lightbox__prev');
  const btnNext      = lightbox.querySelector('.tm-lightbox__next');
  const items        = [...document.querySelectorAll('.presse-page__item')];

  if (!lightbox || items.length === 0) return;

  let currentIndex = 0;

  function openLightbox(index) {
    currentIndex = index;
    const item = items[currentIndex];
    const imagesRaw = item.dataset.images || '';
    const caption = item.dataset.caption || '';
    const imageUrls = imagesRaw.split('|||').filter(Boolean);

    pagesContainer.innerHTML = '';
    imageUrls.forEach((url, i) => {
      const img = document.createElement('img');
      img.src = url;
      img.alt = caption + (imageUrls.length > 1 ? ' — page ' + (i + 1) : '');
      img.className = 'tm-lightbox__page-img';
      img.loading = i === 0 ? 'eager' : 'lazy';
      pagesContainer.appendChild(img);
    });

    captionEl.textContent = caption;
    lightbox.querySelector('.tm-lightbox__content').scrollTop = 0;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    pagesContainer.innerHTML = '';
  }

  function showPrev() {
    currentIndex = (currentIndex - 1 + items.length) % items.length;
    openLightbox(currentIndex);
  }

  function showNext() {
    currentIndex = (currentIndex + 1) % items.length;
    openLightbox(currentIndex);
  }

  items.forEach((item, index) => {
    item.addEventListener('click', () => openLightbox(index));
  });

  btnClose.addEventListener('click', closeLightbox);
  btnPrev.addEventListener('click', (e) => { e.stopPropagation(); showPrev(); });
  btnNext.addEventListener('click', (e) => { e.stopPropagation(); showNext(); });

  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  showPrev();
    if (e.key === 'ArrowRight') showNext();
  });
});
